import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  Typography,
  InputLabel,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import { gql, useMutation } from "@apollo/client";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { companyManagementUrl, setupManagementUrl } from "../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../data/DynamicServiceNew/jsondynamicservice";

const setup_url = setupManagementUrl.uri;
const comp_url = companyManagementUrl.uri;

// Validation schema using Yup
const validationSchema = yup.object().shape({
  initiatorName: yup.string().required("Initiator Name is required"),
  initiatorPassword: yup.string().required("Initiator Password is required"),
  consumerKey: yup.string().required("Consumer Key is required"),
  consumerSecret: yup.string().required("Consumer Secret is required"),
  lipaNaMpesaOnlinePassKey: yup.string().required("Lipa Na Mpesa Online Pass Key is required"),
  shortCode: yup.string().required("Short Code is required"),
  shortCodeTypeId: yup.number().required("Please select a ShortCode Type"),
  regionId: yup.number().required("Please select a Region"),
  branchId: yup.number().required("Please select a Branch"),
});


const MpesaCredentialsForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [shortCodeTypesData, setShortCodeTypesData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [loading, setLoading] = useState(true);
    const [Mappedbranches, setMappedBranches] = useState([]);
    const [selectedRegionId, setSelectedRegionId] = useState([]);
    const [branchoptionsInitialvalue, setBranchOptionsInitialValue] = useState(
      []
    );
      const [branchIdData, setBranchIdData] = useState(null);
    
  
 useEffect(() => {
      async function fetchAllData() {
        try {
          const CodeTypesDataResponse = await fetchJsonDynamic(
            "shortCodeTypes",
            null,
            null,
            setup_url
          );
          const RegionDataResponse = await fetchJsonDynamic(
            "region",
            null,
            null,
            comp_url
          );
          // const BranchDataResponse = await fetchJsonDynamic(
          //   "branch",
          //   null,
          //   null,
          //   comp_url
          // );
          if (RegionDataResponse?.results) {
            const results = JSON.parse(RegionDataResponse?.results);
            setRegionData(results || []);
          }
          // if (BranchDataResponse?.results) {
          //   const results = JSON.parse(BranchDataResponse?.results);
          //   setBranchData(results || []);
          // }
          if (CodeTypesDataResponse?.results) {
            const results = JSON.parse(CodeTypesDataResponse?.results);
            setShortCodeTypesData(results || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchAllData();
    }, []);
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const data = await generateAndExecuteMutation(
        "insertMpesaCredentials",
        values,
        "credentials",
        companyManagementUrl.uri

      );
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Mpesa Credentials inserted successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while inserting Mpesa credentials.",
      });
    } finally {
      setSubmitting(false);
    }
  };
  const fetchBranches = async (regionId) => {
    try {
      console.log("Fetching branches for regionId:", regionId);
      const params = { regionId: parseInt(regionId) };
      console.log("Params for API call:", params);
  
      const businessDetails = await fetchJsonDynamic(
        "allBranchesByColumnValues",
        "branchModel",
        params,
        comp_url
      );
  
      console.log("API Response:", businessDetails);
  
      const allBranchDetails = JSON.parse(businessDetails.results) || [];
      console.log("Parsed branch details:", allBranchDetails);
  
      // Map the branches correctly
      const branchOptions = allBranchDetails.map((branch) => ({
        Id: branch.Id, // Ensure this matches the key used in the MenuItem
        Name: branch.Name, // Ensure this matches the key used in the MenuItem
      }));
  
      console.log("Mapped Branch Options:", branchOptions);
      setMappedBranches(branchOptions); // Update the state with the mapped branches
  
      return branchOptions; // Return the mapped branch options
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };
    const handleFieldChange = async (field, value) => {
      if (field.name === "regionId") {
        console.log("Selected Region ID:", value); // Log the selected region ID
        const branchOptions = await fetchBranches(value);
        console.log("Fetched Branch Options:", branchOptions); // Log the fetched options
        setBranchOptionsInitialValue(branchOptions || []); // Ensure an array is set
        setBranchData(branchOptions); // Set the branch data for further rendering in form
        console.log("Branch Options:", branchOptions); // Log branch options
        setBranchIdData(null); // Reset the branchId data if region changes
      }
    };
  
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const initialValues = {
    initiatorName: "",
    initiatorPassword: "",
    consumerKey: "",
    consumerSecret: "",
    lipaNaMpesaOnlinePassKey: "",
    shortCode: "",
    callbackURL: "",
    shortCodeTypeId: "",
    regionId: "",
    branchId: "",
  };

  return (
    <Box m={2}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="initiatorName"
                  label="Initiator Name"
                  variant="outlined"
                  fullWidth
                  value={values.initiatorName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.initiatorName && Boolean(errors.initiatorName)}
                  helperText={touched.initiatorName && errors.initiatorName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="initiatorPassword"
                  label="Initiator Password"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  value={values.initiatorPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.initiatorPassword &&
                    Boolean(errors.initiatorPassword)
                  }
                  helperText={
                    touched.initiatorPassword && errors.initiatorPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
           
              <Grid item xs={6}>
                <TextField
                  name="consumerKey"
                  label="Consumer Key"
                  variant="outlined"
                  fullWidth
                  value={values.consumerKey}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.consumerKey && Boolean(errors.consumerKey)}
                  helperText={touched.consumerKey && errors.consumerKey}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="consumerSecret"
                  label="Consumer Secret"
                  variant="outlined"
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  value={values.consumerSecret}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.consumerSecret && Boolean(errors.consumerSecret)
                  }
                  helperText={touched.consumerSecret && errors.consumerSecret}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="lipaNaMpesaOnlinePassKey"
                  label="Lipa Na Mpesa Online Pass Key"
                  variant="outlined"
                  fullWidth
                  value={values.lipaNaMpesaOnlinePassKey}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.lipaNaMpesaOnlinePassKey &&
                    Boolean(errors.lipaNaMpesaOnlinePassKey)
                  }
                  helperText={
                    touched.lipaNaMpesaOnlinePassKey &&
                    errors.lipaNaMpesaOnlinePassKey
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="shortCode"
                  label="Short Code"
                  type= "text"
                  variant="outlined"
                  fullWidth
                  value={values.shortCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.shortCode && Boolean(errors.shortCode)}
                  helperText={touched.shortCode && errors.shortCode}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="callbackURL"
                  label="CallbackURL"
                  type= "text"
                  variant="outlined"
                  fullWidth
                  value={values.callbackURL}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.callbackURL && Boolean(errors.callbackURL)}
                  helperText={touched.callbackURL && errors.callbackURL}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Short Code Type</InputLabel>
                  <Select
                    name="shortCodeTypeId"
                    value={values.shortCodeTypeId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.shortCodeTypeId && Boolean(errors.shortCodeTypeId)}
                  >
                    {shortCodeTypesData.map((type) => (
                      <MenuItem key={type.Id} value={type.Id}>
                        {type.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Region</InputLabel>
              <Select
                name="regionId"
                value={values.regionId}
                onChange={(e) => {
                  handleChange(e); // Handle the change in Formik
                  handleFieldChange({ name: "regionId" }, e.target.value); // Fetch branches for the selected region
                }}
                onBlur={handleBlur}
                error={touched.regionId && Boolean(errors.regionId)}
              >
                {regionData.map((type) => (
                  <MenuItem key={type.Id} value={type.Id}>
                    {type.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Branch</InputLabel>
              <Select
                name="branchId"
                value={values.branchId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.branchId && Boolean(errors.branchId)}
              >
                {Mappedbranches.map((branch) => (
                  <MenuItem key={branch.Id} value={branch.Id}>
                    {branch.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
              <Grid item xs={6}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                >
                {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                </Button>

              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default MpesaCredentialsForm;
